import type { App } from 'vue'
import registerTrack from './track/index' // 获取焦点

export default function registerDirectives(app: App) {
  registerTrack(app)
}
